import React, { useCallback, useMemo } from "react";

import { ThemeContainer, AuthContainer } from "@/components/containers";

interface AppContainerProps {
  children?: React.ReactNode;
}

const AppContainer: React.FC<AppContainerProps> = (
  {
    children
  }
) => {

  return (
    <AuthContainer>
      <ThemeContainer>
        {children}
      </ThemeContainer>
    </AuthContainer>
  )

}

export default AppContainer
